import React, { useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Formik, Form, Field } from "formik";
import { PostFinancier, UpdateFinancier } from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";

const AddFinancier = (props) => {
  const { selectedData, formType, setOpenDrawer, title, GetData } = props;
  let formRef = useRef();

  const initialValues = {
    financierType: "",
    financierName: "",
    financierAddress: "",
  };

  useEffect(() => {
    if (formType === "edit") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedData[el];
      });
    }
    formRef.setFieldValue(initialValues);
  }, []);

  const UserId = sessionStorage.getItem("UserId");

  const onKeyDownHandler = (e, values) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit(e, values, "Save");
    }
  };

  const onSubmit = (e, data, actionKey) => {
    ["financierType", "financierName","financierAddress"].forEach(
      (item) => (data[item] = data[item]?.toUpperCase())
    );
    const isValid = data?.financierType && data?.financierName && data?.financierAddress;
    if (e?.key === "Enter" || actionKey === "Save") {
      if (isValid) {
        const payload = { ...data };
        payload.updatedAt = new Date();
        if (formType === "add") payload.createdBy = UserId; else if (formType === "edit") payload.updatedBy = UserId;
        const submit = formType === "edit"
          ? UpdateFinancier(selectedData._id, payload)
          : PostFinancier(payload);
        submit
          .then((res) => {
            if (!res) {
              setOpenDrawer(true);
            } else {
              setOpenDrawer(false);
              GetData();
            }
          })
          .catch((error) => console.log(error));
      } else {
        ToastError("Fill all the fields!!");
      }
    } else if (actionKey === "Save&Create") {
      if (isValid) {
        PostFinancier(data).then((res) => {
          if (res) {
            formRef.resetForm();
          }
          GetData();
        });
      } else {
        ToastError("Fill all the fields!!");
      }
    }
  };

  return (
    <>
      <div className="DrawerContainer">
        <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography>{title} Financier</Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon onClick={() => setOpenDrawer(false)} sx={{ cursor: "pointer" }} />
          </Grid>
        </Grid>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          innerRef={(ref) => {
            if (ref) {
              formRef = ref;
            }
          }}
        >
          {({ values, handleChange }) => (
            <Form onKeyDown={(e) => onKeyDownHandler(e, values)}>
              <div className={Styles.addContent}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                      Financier Type
                    </Typography>
                    <Field name="financierType" placeHolder="Enter Financier Type" className="InputFiled" style={{ textTransform: "uppercase", }} />
                  </Grid>
                  
                  <Grid item xs={12} sm={6}>
                    <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                      Financier Name
                    </Typography>
                    <Field name="financierName" className="InputFiled" placeHolder="Enter Financier Name" style={{ textTransform: "uppercase", }}/>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                      Financier Address
                    </Typography>
                    <Field name="financierAddress" as="textarea" className="InputFiled" placeHolder="Enter Address" rows={3} style={{ textTransform: "uppercase" }} />
                  </Grid>
                </Grid>
              </div>
              <div className="Dialog_Footers">
                <div className="Dialog_Button_Groups">
                  <Button onClick={() => setOpenDrawer(false)} className="Dialog_Cancels">
                    Cancel
                  </Button>
                  <Button type="submit" onClick={(e) => onSubmit(e, values, "Save")} className="Dialog_Saves">
                    {selectedData?._id ? "Update" : "Save & Exit"}
                  </Button>
                </div>
                <Button sx={{ display: formType === "add" ? "block" : "none", marginLeft: "10px" }} className="Dialog_Save_Exits" onClick={(e) => onSubmit(e, values, "Save&Create")}>
                  Save & Create New
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AddFinancier;


